import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

function open_Lightbox(){
  let query = wixLocation.query;
  var goto = query.name;
  wixWindow.openLightbox(goto);
}

$w.onReady(function () {
  open_Lightbox();
});


export function aboutnavwrap_click(event) {
	if( $w("#navabout").collapsed ) {
  		$w("#navabout").expand();
	}
	
	else {
  		$w("#navabout").collapse();
	}

	if( $w("#navprog").expand ) {
  		$w("#navprog").collapse();
	}

	if( $w("#navreg").expand ) {
  		$w("#navreg").collapse();
	}
}

export function prognavwrap_click(event) {
	if( $w("#navprog").collapsed ) {
  		$w("#navprog").expand();
	}
	
	else {
  		$w("#navprog").collapse();
	}

	if( $w("#navabout").expand ) {
  		$w("#navabout").collapse();
	}

	if( $w("#navreg").expand ) {
  		$w("#navreg").collapse();
	}
}

export function regnavwrap_click(event) {
	if( $w("#navreg").collapsed ) {
  		$w("#navreg").expand();
	}
	
	else {
  		$w("#navreg").collapse();
	}

	if( $w("#navabout").expand ) {
  		$w("#navabout").collapse();
	}

	if( $w("#navprog").expand ) {
  		$w("#navprog").collapse();
	}
}


$w.onReady(function () {
  $w("#sponsorsRepeater").onItemReady(($item, itemData, index) => {
    $item("#sponsorText").text = itemData.eb21SponsorLevel;
    $item("#sponsorLogo").src = itemData.logo;
    $item("#sponsorLink").link = itemData.website;
  });

  wixData.query("Companies")
    .ascending("eb21SponsorSort")
    .isNotEmpty("eb21SponsorLevel")
    .find()
    .then((results) => {
      if (results.totalCount > 0) {
        $w("#sponsorsRepeater").data = results.items;
      } 
    })
    .catch((error) => {
      console.log("Error:", error.message);
    }); 
});

$w.onReady(function () {
    $w("#advertsBannerDS").onReady(() => {
       let items = $w("#advertsBannerDS").items;
       items = shuffle(items);
       $w("#advertsBannerDS").items = items;
    });

	function shuffle(array) {
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
   			[array[i], array[j]] = [array[j], array[i]];
		}

		return array;
	}
});